import React from "/vendor/react";
import PropTypes from "prop-types";
import { makeStyles } from "/vendor/@material-ui/core";

// Druga linia w pozycji listy zdarzeń: pokazuje output checka.
// Jedna i dwie linie są zawsze w całości. Przy trzech i więcej output
// jest zwinięty do dwóch linii, a resztę odkrywa „Pokaż więcej".

// Usuwa sekwencje ANSI (kolory), żeby output ładnie wyglądał na liście.
const stripAnsi = (str) =>
  str.replace(/\x1b\[[0-9;]*m/g, ""); // eslint-disable-line no-control-regex

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 2,
    marginBottom: 2,
  },
  output: {
    fontFamily:
      "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace",
    fontSize: "0.8125rem",
    lineHeight: 1.5,
    color: theme.palette.text.primary,
    whiteSpace: "pre-wrap !important",
    wordBreak: "break-word",
    overflow: "visible !important",
    textOverflow: "clip !important",
    margin: 0,
  },
  collapsed: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden !important",
  },
  toggle: {
    display: "inline-block",
    marginTop: 2,
    padding: 0,
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.palette.primary.main,
    fontSize: "0.75rem",
    fontWeight: 600,
    fontFamily: "inherit",
  },
}));

const EventOutput = ({ output }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const text = stripAnsi((output || "").trim());
  if (!text) {
    return null;
  }

  const lineCount = text.split("\n").length;
  const needsToggle = lineCount > 2;

  const handleToggle = (e) => {
    // Nie propaguj kliknięcia do wiersza / linku zdarzenia.
    e.preventDefault();
    e.stopPropagation();
    setExpanded((v) => !v);
  };

  return (
    <div className={classes.root}>
      <div
        className={`${classes.output} ${
          needsToggle && !expanded ? classes.collapsed : ""
        }`}
      >
        {text}
      </div>
      {needsToggle && (
        <button type="button" className={classes.toggle} onClick={handleToggle}>
          {expanded ? "Zwiń" : "Pokaż więcej"}
        </button>
      )}
    </div>
  );
};

EventOutput.propTypes = {
  output: PropTypes.string,
};

EventOutput.defaultProps = {
  output: "",
};

export default EventOutput;
